// extracted by mini-css-extract-plugin
module.exports = {"table-container":"NotConfirmedOrders_table-container__1BJrw","table":"NotConfirmedOrders_table__KmXaI"};